import { Link } from 'react-router-dom';
import Avatar from '../components/Avatar';
import { ThemeBackdrop } from '../lib/themeEmblem';
import { lockedPersona, lockedTheme, PERSONAS, PERSONA_TO_THEME } from '../lib/personas';
import { useTheme } from '../lib/useTheme';

export default function Lab() {
  const theme = useTheme();
  const readerLock = lockedPersona();
  const themeLock = lockedTheme();

  return (
    <main className="relative isolate min-h-screen">
      <ThemeBackdrop theme={theme} />
      <article className="relative z-10 mx-auto w-full max-w-5xl px-6 pb-24 pt-24 sm:pt-28">
        <Link to="/" className="text-sm text-muted hover:text-fg">← 返回首頁</Link>
        <p className="mt-14 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-accent">
          Lab
        </p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl leading-tight text-heading sm:text-6xl">
          展示單一 SKU、占卜師鎖定與主題鎖定的客戶版本。
        </h1>
        <div className="mt-10 grid gap-5 lg:grid-cols-[1fr_1.2fr]">
          <section
            className="border bg-elevated/78 p-5 backdrop-blur-xl"
            style={{ borderColor: 'var(--color-border)', borderRadius: 'var(--radius-card)' }}
          >
            <p className="font-mono text-[0.62rem] uppercase tracking-[0.18em] text-accent">Env lock</p>
            <dl className="mt-4 grid gap-3 text-sm">
              <div>
                <dt className="text-muted">VITE_SKU_LOCK / VITE_LOCK_READER</dt>
                <dd className="font-display text-2xl text-heading">{readerLock ?? '未鎖定'}</dd>
              </div>
              <div>
                <dt className="text-muted">VITE_LOCK_THEME</dt>
                <dd className="font-display text-2xl text-heading">{themeLock ?? '跟隨版本'}</dd>
              </div>
            </dl>
            <Link
              to="/try/healing"
              className="mt-6 inline-flex px-5 py-3 text-sm font-semibold"
              style={{ background: 'var(--btn-bg)', color: 'var(--btn-ink)', borderRadius: 'var(--radius-pill)' }}
            >
              開啟試玩入口
            </Link>
          </section>
          <section className="grid gap-3 sm:grid-cols-3">
            {PERSONAS.map((persona) => {
              const lockedOut = Boolean(readerLock && readerLock !== persona);
              return (
                <div
                  key={persona}
                  className={['border bg-elevated/72 p-4 backdrop-blur-xl', lockedOut ? 'opacity-40' : ''].join(' ')}
                  style={{ borderColor: 'var(--color-border)', borderRadius: 'var(--radius-card)' }}
                >
                  <Avatar persona={persona} className="h-14 w-14" alt={persona} />
                  <h2 className="mt-4 font-display text-2xl text-heading">{persona}</h2>
                  <p className="mt-1 font-mono text-[0.6rem] uppercase tracking-[0.16em] text-accent">
                    {themeLock ?? PERSONA_TO_THEME[persona]}
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-muted">
                    {lockedOut ? '單一 SKU 鎖定時不會出現在 session 選擇中。' : '可用於目前 demo 的固定占卜師。'}
                  </p>
                </div>
              );
            })}
          </section>
        </div>
      </article>
    </main>
  );
}
